<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="下单时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import cityCompanyApi from '@/api/sys/cityCompany'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
      },
      standingList:[]
    }
  },
  created() {
    // this.sectionList=JSON.parse(localStorage.getItem('levelList'))
  },
  methods: {
    handleDownload() {
      let query={}
      query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : ""
      query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : ""
      return this.$common.confirm('是否确认导出')
        .then(() => cityCompanyApi.exportCityCompanyTotal(query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)
          }
        })
    },
  }
}
</script>

<style>
</style>
